

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface StockTransactionParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface StockTransaction {

  fromDate: any;
  ToDate: any;
 
  Supplier: string;
   
  skip:Number,
  take:Number,
    tenantId?: string;
    branchId?: string;
    
  
    parameters?: StockTransactionParameter[];
    links?: any;
}

export abstract class StockTransactionData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<StockTransaction[]>;
  abstract searchList(url: string,data: any): Observable<any>;
  abstract update(url: string,data: StockTransaction): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
